import type { ReactElement } from 'react';
import React, { useMemo, useState } from 'react';
import NavigationTabs from 'atom-components/navigation-tabs';
import MainLayout from 'layouts/main';
import MyAssignmentsTab from 'pages/dashboard/components/my-assignments-tab';
import MySubscriptionsTab from 'pages/dashboard/components/my-subscriptions-tab';
import { ROLE } from 'services/assist-api/entities/role/roles';
import { useRoleMatch } from 'services/providers/auth.hooks';

const TAB_MY_SUBSCRIPTIONS = {
  name: 'My Subscriptions'
};
const TAB_MY_ASSIGNMENTS = {
  name: 'My Assignments'
};

export default function DashboardPage(): ReactElement {
  const showProducts = useRoleMatch([ROLE.SITE_ADMIN, ROLE.ADMIN, ROLE.TEACHER]);

  const tabs = useMemo(
    () => (showProducts ? [TAB_MY_SUBSCRIPTIONS, TAB_MY_ASSIGNMENTS] : [TAB_MY_ASSIGNMENTS]),
    [showProducts]
  );
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <MainLayout
      title="Dashboard"
      navigationTabs={
        <NavigationTabs tabs={tabs} activeTab={activeTab} handleClickTab={setActiveTab} />
      }
    >
      {activeTab === TAB_MY_SUBSCRIPTIONS && <MySubscriptionsTab />}
      {activeTab === TAB_MY_ASSIGNMENTS && <MyAssignmentsTab />}
    </MainLayout>
  );
}
